import { PrettyRating } from './components/pretty-rating';
export default PrettyRating;
